import { Component, OnInit } from "@angular/core";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { Title } from "@angular/platform-browser";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";

@Component({
  selector: "app-pep",
  templateUrl: "./pep.component.html",
  styleUrls: ["./pep.component.scss"],
})
export class PepComponent extends DefaultPageComponent implements OnInit {
  analyticsPageGA4: AnalyticsGA4PagesModel;
  headerId = "pep";
  titlePage = "Dados profissionais";
  startStage = "1";
  endStage = "4";
  analyticsPage: AnalyticsPageModel;
  idLabelPep = "labelPep";
  idButtonPepYes = "buttonPepYes";
  idButtonPepNo = "buttonPepNo";

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    private title: Title,
    public journeyService: JourneyService,
    public analycticsNativeService: AnalycticsNativeService,
    public returnNativeService: ReturnNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.analyticsData();
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getPageId(): string {
    return this.headerId;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  analyticsData() {
    //tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage.pep;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = "Clique";
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.pep,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  clickNext(btSim: boolean) {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = "Clique";
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: btSim ? "BTN:Sim" : "BTN:Nao",
      it_pagename: this.analyticsPage.pep,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );

    this.nextPage();
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPahExpostaPoliticamente,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }
}
